export const TOGGLE_WORKPLACE_ADMINISTRATION =
	'SHIFTPLANNER_WORKPLACE_ADMINISTRATION/TOGGLE_WORKPLACE_ADMINISTRATION';

export function toggleWorkplaceAdministration() {
	return {
		type: TOGGLE_WORKPLACE_ADMINISTRATION
	};
}
